import React from 'react';
import './PolicyPages.css';

const ReturnsExchange = () => {
  return (
    <div className="policy-page">
      <div className="container">
        <div className="policy-header">
          <h1>Exchange Policy</h1>
          <p>Last updated: {new Date().toLocaleDateString()}</p>
        </div>

        <div className="policy-content">
          <section>
            <h2>Exchange Policy (Defective Products Only)</h2>
            <p>We do not accept returns for change of mind or incorrect fit. Exchanges are only provided for products that are defective, damaged, or have manufacturing defects.</p>
          </section>

          <section>
            <h2>Eligibility for Exchange</h2>
            <ul>
              <li>Product must be defective, damaged, or have manufacturing defects</li>
              <li>Exchange request must be made within 7 days of delivery</li>
              <li>Product must be unused and in original packaging</li>
              <li>All original tags, accessories, and documents must be included</li>
              <li>Proof of purchase (order number or invoice) is required</li>
            </ul>
          </section>

          <section>
            <h2>What Qualifies as Defective?</h2>
            <ul>
              <li>Broken or cracked lenses upon delivery</li>
              <li>Misaligned or broken frames</li>
              <li>Missing screws or loose hinges</li>
              <li>Incorrect prescription (verified by optometrist)</li>
              <li>Scratched or damaged lenses (not caused by user)</li>
              <li>Manufacturing defects in frame finish</li>
            </ul>
          </section>

          <section>
            <h2>What Does NOT Qualify for Exchange?</h2>
            <ul>
              <li>Change of mind or style preference</li>
              <li>Incorrect fit or size (unless sizing was incorrect in product listing)</li>
              <li>Normal wear and tear</li>
              <li>Damage caused by improper use or handling</li>
              <li>Lost or stolen items</li>
              <li>Products damaged after delivery</li>
              <li>Prescription lenses ordered incorrectly by customer</li>
            </ul>
          </section>

          <section>
            <h2>How to Request an Exchange</h2>
            <ol>
              <li>Contact our customer support within 7 days of delivery</li>
              <li>Provide your order number and clear photos/videos of the defect</li>
              <li>Our team will review and verify the defect</li>
              <li>If approved, we will arrange for pickup of the defective product</li>
              <li>After inspection, we will ship the replacement product</li>
            </ol>
          </section>

          <section>
            <h2>Exchange Process Timeline</h2>
            <ul>
              <li>Defect verification: 1-2 business days</li>
              <li>Product pickup: 2-3 business days</li>
              <li>Quality inspection: 1-2 business days after receipt</li>
              <li>Replacement shipping: 2-3 business days after approval</li>
            </ul>
          </section>

          <section>
            <h2>Shipping Costs</h2>
            <p>For defective products approved for exchange, we will cover the shipping costs for both pickup and delivery of the replacement product.</p>
          </section>

          <section>
            <h2>Prescription Eyewear</h2>
            <p>If the prescription lenses were manufactured incorrectly based on your submitted prescription, we will exchange them at no cost. Please have your optometrist verify the lenses if needed.</p>
          </section>

          <section>
            <h2>Contact for Exchange Requests</h2>
            <p>Email: kadharvco@gmail.com<br />
            Phone: +91 94436 53501<br />
            Please include your order number and photos of the defect.</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default ReturnsExchange;